//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/**
 README
 - This file is for Curalate-specific shared functionality (functions, plugins, components such as forms, etc.)
 - All function "libraries" (i.e. list of functions returned by a self-executing anonymous function) should be prefaced with crl8.shared.<descriptive namespace>
 - All objects intended to be used as a class should be prefaced with crl8.shared.class.<className> and should ensure that they are called with the new
    operator. See this for reference: http://ejohn.org/apps/learn/#38
 - All plugins should start with crl8Shared. i.e. $.fn.crl8SharedFoo = function()...
 */

window.crl8 = window.crl8 || {};
crl8.shared = crl8.shared || {};

crl8.shared.tags = (function() {

    // This is the client-side protection and should match the server-side checks done in BrandTags.scala (and in the mobile app).
    var WINDOWS_1252_PATTERN = "[^\\u0000-\\u007FƒŠŒŽšœžŸªµº©™®\\u00c0-\\u00d6\\u00d8-\\u00f6\\u00f8-\\u00ff]";
    var TAG_SANITIZE_PATTERN = WINDOWS_1252_PATTERN + "|[&,:;=@#|+?><~{}^()`/\\]\\[!$\"%\'\\\\©®™.*]";

    var validTag = function(tag) {
        if (tag.length > 0) {
            var tagRegex = new RegExp(TAG_SANITIZE_PATTERN, "g");
            return !tagRegex.test(tag);
        } else {
            return false;
        }
    };

    var sanitizeTag = function(tag) {
        var tagRegex = new RegExp(TAG_SANITIZE_PATTERN, "g");
        var strippedTag = tag.replace(tagRegex, "").toLowerCase().replace(/ /g, '-');
        return encodeTag(strippedTag);
    };

    var encodeTag = function(tag) {
        return encodeURIComponent(tag);
    };

    return {
        sanitize: function(tag) {
            return sanitizeTag(tag);
        },

        encode: function(tag) {
            return encodeTag(tag);
        },

        valid: function(tag) {
            return validTag(tag);
        }
    };
})();
